export const USER_ID_PARAM = "userid";
export const USER_NAME_PARAM = "username";
export const SERVICE_ID_PARAM = "serviceid";
export const SERVICE_NAME_PARAM = "servicename";
export const SERVICE_TYPE_PARAM = "servicetype";
export const SERVICE_TYPE_NAME_PARAM = "servicetypename";
export const SERVICE_TYPE_ID_PARAM = "servicetypeid";
export const DATE_RANGE_PARAM = "daterange";
export const DATE_RANGE_PARAM_START = "startdate";
export const DATE_RANGE_PARAM_END = "enddate";
